import * as React from 'react';
import { Transfer as DesignTransfer } from '@whalecloud/fdx';

const { useState } = React;

const Transfer = ({ element }) => {
  const { componentSettings, settings, className = '' } = element.data;
  const { visible } = settings;
  const { label, key, dataList = [], titles=["Source", "Target"], ...rest } = componentSettings;
  const [targetKeys, setTargetKeys] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);

  return (
    <DesignTransfer
      titles = {titles}
      style={{ width: '100%', visibility: visible }}
      className={className}
      dataSource={dataList.map((v, index) => Object.assign(v, { key: v[key] || index }))}
      {...rest}
      // {...formItemSettings}
      render={item => item[label]}
      targetKeys={targetKeys}
      selectedKeys={selectedKeys}
      onChange={(nextTargetKeys) => {
        setTargetKeys(nextTargetKeys);
      }}
      onSelectChange={(sourceSelectedKeys, targetSelectedKeys) => {
        setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
      }}
    />
  );
};

export default Transfer;
